<template>
  <v-dialog height="500" max-width="500" v-model="show">
    <v-card :dark="!themeWhite" :light="themeWhite" :style="setBackground">
      <v-card-title>
        <div v-show="type === 'notice'" class="notice-title-style notice-color">NOTICE</div>
        <div v-show="type === 'resource'" class="notice-title-style resource-color">RESOURCE</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mt-0"></v-divider>
      <v-card-text class="py-0" v-show="!write">
        <v-row>
          <v-col cols="12" sm="9" class="d-flex align-center">
            <span class="text-left text-h5 font-weight-bold">{{ innerContent.title }}</span>
          </v-col>
          <v-col cols="12" sm="3" class="pb-0">
            <p><span class="bottom_txt text-right text-body-2">{{ txtDate }}</span></p>
            <span class="bottom_txt text-right text-body-2">{{ innerContent.insuser }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-show="false">
        <v-select
          v-model="innerContent.pushOn"
          :items="groupList"
          label="알림 대상"
          :disabled="!write"
        ></v-select>
        <v-select
          v-model="innerContent.subType"
          :items="siteList"
          label="사이트 구분"
          :disabled="!write"
        ></v-select>
        <v-text-field v-model="innerContent.pushTitle" label="알림 제목" :readonly="!write"></v-text-field>
        <v-textarea v-model="innerContent.pushContent" :readonly="!write">
          <template v-slot:label>
            <div>
              알림 내용
            </div>
          </template>
        </v-textarea>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-text>
        <v-text-field v-model="innerContent.title" label="제목" v-show="edit"></v-text-field>
        <v-textarea label="내용" v-model="innerContent.content" :readonly="!edit" >
        </v-textarea>
      </v-card-text>
      <v-card-text v-show="admin">
        <v-row class="justify-end">
          <v-col class="text-right">
            <v-btn outlined class="mr-1 default-btn" @click="saveNotice">
              저장
            </v-btn>
            <v-btn outlined class="default-btn" @click="deleteNotice" v-show="!write">
              삭제
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getUserGroup } from '@/api/greenCommon/user'
import { setNotice, deleteNotice } from '@/api/greenCommon/common'
import localStore from '@/utils/localStore'
import Message from '@/utils/message'
import day from 'dayjs'

export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'NoticeDialog',
  props: {
    context: {
      type: Object
    },
    showEvent: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean
    },
    write: {
      type: Boolean,
      default: false
    },
    admin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      groupList: [
        {
          text: '없음',
          value: ''
        }
      ],
      siteList: [
        {
          text: '없음',
          value: ''
        },
        {
          text: 'W (센트럴인버터)',
          value: 'W'
        },
        {
          text: 'M (친트 RTU)',
          value: 'M'
        },
        {
          text: 'E (ESS)',
          value: 'E'
        },
        {
          text: 'A (친트인버터)',
          value: 'A'
        }
      ],
      innerContent: {
        title: '',
        date: '',
        insuser: '',
        pushOn: '',
        pushTitle: '',
        pushContent: '',
        subType: '',
        content: ''
      }
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    getUserGroup().then(response => {
      for (let i in response) {
        this.groupList.push({
          text: response[i].usergroup_title,
          value: response[i].usergroup_id
        })
      }
    })
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  watch: {
    showEvent(newValue) {
      this.show = true
      this.initContext()
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    setBackground() {
      return this.white ? 'background-color: #fff' : ''
    },
    type() {
      return this.context.type
    },
    edit() {
      return this.admin || this.write
    },
    themeWhite() {
      return this.white ? this.white : !this.$vuetify.theme.dark
    },
    txtDate() {
      return day(this.context.date).format('YYYY-MM-DD')
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    initContext() {
      this.innerContent = this.context
    },
    saveNotice() {
      let data = {
        title: this.context.title,
        content: this.context.content,
        insuser: localStore.get('userId'),
        row_num: this.context.rowNum
      }
      setNotice(data).then(res => {
        Message.success('저장되었습니다.')
        this.show = false
        this.$emit('refresh')
      })
    },
    deleteNotice() {
      let data = {
        row_num: this.context.rowNum
      }
      deleteNotice(data).then(res => {
        Message.success('삭제되었습니다.')
        this.show = false
        this.$emit('refresh')
      })
    }
  }
}
</script>
